import type { QueryClient } from '@tanstack/react-query';
import type { MailApi } from '@/api/contract';
import { queryKeys } from '@/api/queryKeys';
import type { Task } from '@/api/types';
import { enqueueTaskWrite } from '@/features/tasks/writeQueue';

/** Undo: the tasks just made, deleted again (idempotent on the server). */
export async function deleteEmailTasks(
  api: MailApi,
  client: QueryClient,
  created: ReadonlyArray<{ accountId: string; task: Task }>,
): Promise<void> {
  const accounts = new Set<string>();
  await Promise.all(
    created.map(({ accountId, task }) => {
      accounts.add(accountId);
      return enqueueTaskWrite(accountId, () => api.tasks.deleteTask(accountId, task.id));
    }),
  );
  for (const accountId of accounts) {
    void client.invalidateQueries({ queryKey: queryKeys.account(accountId).tasksScope() });
  }
}
